import {GeneratedLayout} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';

import styles from './ReportSummary.less';
import ReportSummaryItem from './ReportSummaryItem';
import {ReportConfig} from 'src/js/model/reports_config';

const STATIC_EMPTY_OBJECT = {};

class ReportSummary extends React.PureComponent {
  render() {
    const {reportData, reportConfig} = this.props;
    const reportDataValues = reportData[0] || STATIC_EMPTY_OBJECT;

    return (
      <div className={styles.dlReportSummary}>
        {reportConfig &&
        reportConfig.getOptions() &&
        reportConfig.getOptions().getGeneratedLayout() &&
        reportConfig.getOptions().getGeneratedLayout().getComponents().length >
          0 ? (
          <GeneratedLayout
            reportConfig={reportConfig}
            reportDataValues={reportDataValues}
            layoutConfig={reportConfig.getOptions().getGeneratedLayout()}
            dataMap={reportConfig.getOptions().getDataMap()}
            dataComponent={ReportSummaryItem}
            dataPropName={'data'}
          />
        ) : null}
      </div>
    );
  }
}

ReportSummary.displayName = 'ReportSummary';

ReportSummary.propTypes = {
  reportConfig: PropTypes.instanceOf(ReportConfig).isRequired,
  reportData: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default ReportSummary;
